import { Injectable } from '@angular/core';
import { ITypedResponse } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IDeviceNode, IDeviceInformation } from '@caslink/device-client/ng-app/shared/models/device';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {
    public static $name = 'scheduleService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getScheduling(hardwareItemId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getScheduling',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<IDeviceNode>();
    }

    public updateScheduling(device: IDeviceInformation): angular.IPromise<ITypedResponse<string>> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'updateScheduling',
            data: device.$deviceHierarchy
        }).as<ITypedResponse<string>>().then((response: ITypedResponse<string>) => {
            return response;
        });
    }

    public saveSchedulingTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'saveSchedulingTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<any>().then((response: any) => {
            return response;
        });
    }

    public previewSchedulingTemplate(device: IDeviceInformation, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'previewSchedulingTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel>();
    }

    

    public getSchedulingTemplates(hardwareItemId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getSchedulingTemplates',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public applySchedulingTemplate(device: IDeviceInformation, hardwareItemId: number, templateId: string): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'applySchedulingTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateId: templateId
            }
        }).as<IDeviceNode>();
    }

    public importCaalToScheduling(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<IDeviceNode> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'importCaalToScheduling',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<IDeviceNode>();
    }

    public exportSchedulingToCaal(device: IDeviceInformation, hardwareItemId: number, documentId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'exportSchedulingToCaal',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<number>().then((response: number) => {
            return response;
        });
    }


    public getCanManageTemplates(): angular.IPromise<boolean> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getCanUseSchedulingTemplates'
        }).as<boolean>();
    }

    public getIsCommissionerModelSupported(device: IDeviceInformation): angular.IPromise<boolean> {
        const identifier = device.$deviceHierarchy.identifier;
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'isCommissionerModelSupported',
            queryParams: {
                'viewModelIdentifier.actorType': identifier.actorType,
                'viewModelIdentifier.entityId': identifier.entityId,
                'viewModelIdentifier.entityType': identifier.entityType,
                'viewModelIdentifier.viewModelType': identifier.viewModelType,
            }
        }
        ).as<boolean>();
    }

}
